import { useEffect, useState } from 'react';
import { appsApi, CrossmintVerificationStatus } from '@/api/apps';
import useMainStore from '@/store/mainStore';

/**
 *
 * @param param Needs hook usage audit to avoid rerenders
 */
export function useInitializeCrossMintOnce() {
  const { studioInstance, setCrossmintEnabled } = useMainStore();
  const [initialized, setInitialized] = useState(false);

  useEffect(
    () => {
      const initialize = async () => {
        // @dev: used initialized to prevent multiple calls to crossmint
        if (!initialized && studioInstance?.publicData.crossmintClientId) {
          try {
            const verifyResponse = await appsApi.getCrossmintVerificationStatus(
              studioInstance.publicData.crossmintClientId,
            );

            if (!verifyResponse) {
              return;
            }

            const sellerStatus = verifyResponse?.verificationStatus?.seller?.status;
            const collectionStatus = verifyResponse?.verificationStatus?.collection?.status;
            const isVerified =
              sellerStatus === CrossmintVerificationStatus.VERIFIED &&
              collectionStatus === CrossmintVerificationStatus.VERIFIED;
            setCrossmintEnabled(isVerified);
            setInitialized(true);
          } catch {
            console.warn('Failed to verify crossmint');
            setInitialized(true);
          }
        }
      };
      initialize();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [studioInstance],
  );
}
